export default __webpack_public_path__ + "assets/images/45940f6cb1263a13a3e5abb4730ff339.svg";